import React from 'react';
import PropTypes from 'prop-types';
import { bemComponent } from '@99designs/common/utils/app';

export default class TagButtonGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showMorePills: false };
        this.showMorePills = this.showMorePills.bind(this);
    }

    getInitialPillItems() {
        return this.props.tags.slice(0, 5).map((tag, i) => this.pillTag(tag, i));
    }

    pillTag(tag, key) {
        const Pill = bemComponent('pill', 'Pill');
        return (
            <div className="pill-group__item" key={key}>
                <a href={tag.href}>
                    <Pill variations={['tag']}>{tag.name}</Pill>
                </a>
            </div>
        );
    }

    maybeMorePillItems() {
        if (this.props.tags.length > 5) {
            return (
                <span>
                    {this.state.showMorePills ? this.extraPills() : this.extraPillsButton()}
                </span>
            );
        }

        return null;
    }

    showMorePills() {
        this.setState({ showMorePills: true });
    }

    extraPillsButton() {
        return (
            <div className="pill-group__item">
                <span className="pill pill--tag pill--t1000">
                    <button type="button" className="pill__button" onClick={this.showMorePills}>
                        {`+ ${this.props.tags.length - 5}`}
                    </button>
                </span>
            </div>
        );
    }
    extraPills() {
        return this.props.tags.slice(5).map((tag, i) => this.pillTag(tag, i + 5));
    }

    render() {
        return (
            <div className="pill-group">
                {this.getInitialPillItems()}
                {this.maybeMorePillItems()}
            </div>
        );
    }
}

TagButtonGroup.propTypes = {
    tags: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/TagButtonGroup.jsx